import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';

export let updateEditAltPassword = mutatorAction('updateEditAltPassword', (password: string) => {
    let store = connectedAccountsStore();
    store.editAccountState.altPassword = password;
});
